import { useEffect } from "react"
import { garantiasRows } from "../components/GarantiasSection/constants"

const isNaoTem = (value) =>
    typeof value === "string" && value.trim().toLowerCase() === "não tem"

export const useValorGarantia = (garantiasState, setGarantiasState) => {
    useEffect(() => {
        garantiasRows.forEach((row) => {
            if (row.isDivider || row.isLine) return

            const textKey = row.key
            const valueKey = `${row.key}Valor`
            const checkKey = `${row.key}Check`

            if (!garantiasState?.[checkKey]) return

            const currentValor = garantiasState?.[valueKey]
            const textValue = garantiasState?.[textKey]

            // 🔴 REGRA FIXA: SOBREGARANTIA = 100
            if (row.key === "sobreGarantia") {
                if (currentValor !== 100) {
                    setGarantiasState((prev) => ({
                        ...prev,
                        [valueKey]: 100,
                    }))
                }
                return
            }

            // não sobrescreve valor manual
            if (currentValor !== 0 && currentValor !== 1) return

            const nextValor = isNaoTem(textValue) ? 0 : 1

            if (currentValor !== nextValor) {
                setGarantiasState((prev) => ({
                    ...prev,
                    [valueKey]: nextValor,
                }))
            }
        })
    }, [garantiasState, setGarantiasState])
}
